import React from 'react';
import * as _Builtin from './_Builtin';
import * as _utils from './utils';
import _styles from './DevlinkStatsSection.module.css';

export function DevlinkStatsSection({ as: _Component = _Builtin.Section, statItems }) {
  return (
    <_Component
      className={_utils.cx(_styles, 'ht-stats-section')}
      grid={{
        type: 'section',
      }}
      tag="section"
    >
      <_Builtin.Block className={_utils.cx(_styles, 'ht-container', 'lg')} tag="div">
        <_Builtin.Block className={_utils.cx(_styles, 'ht-stats-group')} tag="div">
          {statItems}
        </_Builtin.Block>
      </_Builtin.Block>
    </_Component>
  );
}
